import { createContext } from 'react';
import { AppContext as TAppContext } from './types';

export const AppContext = createContext<TAppContext>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  null as any,
);
